import { App } from "antd";

// Bridge so non-component code (axios handlers, websocket helpers) can reach
// the context-aware antd message/notification/modal instances. Static antd
// methods are inert under React 19 without these hook instances.
type StaticApi = ReturnType<typeof App.useApp>;

export const staticAntd: {
  message: StaticApi["message"] | null;
  notification: StaticApi["notification"] | null;
  modal: StaticApi["modal"] | null;
} = {
  message: null,
  notification: null,
  modal: null,
};

export const setStaticAntd = (api: StaticApi): void => {
  staticAntd.message = api.message;
  staticAntd.notification = api.notification;
  staticAntd.modal = api.modal;
};
